import { z } from 'zod';

// SQLite stores UTC naïf timestamps via strftime('%Y-%m-%dT%H:%M:%S','now') — no trailing Z.
// Responses also include *_norm_utc fields that always have the Z suffix.
export const utcNaiveTimestamp = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/, 'expected UTC naïf timestamp (no Z)');

export const utcIsoTimestamp = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/, 'expected ISO UTC timestamp (with Z)');

export const idParam = z.object({
  id: z.coerce.number().int().positive(),
});

export const nonEmptyString = z.string().trim().min(1);

// SQLite boolean as integer 0/1.
export const sqliteBool = z.union([z.literal(0), z.literal(1)]);
export const boolish = z.union([z.boolean(), sqliteBool]).transform((v) => (v === 1 || v === true ? 1 : 0));
